import React from 'react'
import './DiscoverHeader.css'

const DiscoverHeader = () => {
    return (
        <div className="DiscoverFilter">
            <div className="discoverBySortCenter">
                <div className="filterAreaLeft">
                    <h6 className="filterSortLabel">Category:</h6>
                    <select className="selectDropdownItem" name="" id="">
                        <option value="">All</option>
                        <option value="">Art</option>
                        <option value="">Music</option>
                        <option value="">Domain Name</option>
                        <option value=""></option>
                    </select>
                </div>
                <div className="filterAreaRight">
                    <div className="sortNav">
                        <button className="sortNavBtn">Newest</button>
                        <button className="sortNavBtn">Best Selling</button>
                        <button className="sortNavBtn">Like</button>
                    </div>
                   <div className="shortBy">
                    <h6 className="filterSortLabel">Sort by:</h6>
                        <select name="" id="" className="selectDropdownItem">
                            <option value="activaity">Recently Active</option>
                            <option value="actionEnding">Ending</option>
                            <option value="lowestPrice">Lowest Price</option>
                            <option value="highestPrice">Highest Price</option>
                            <option value="highestTokentId">Newest</option>
                            <option value="lowestTokentId">Oldest</option>
                        </select>
                   </div>
                </div>
            </div>
        </div>
    )
}

export default DiscoverHeader
